
        require('./index.scss');
        'use strict';

var $ = window.$;
var $mod = $('.module-auto-sem');
var _module = {
    init: function init() {
        var $need = $mod.find('[node-type="autosemneed"]');
        var needAutoSEM = $need.data('need');
        if (needAutoSEM !== 'need') {
            return;
        }

        var document = window.document;
        // baidu push
        var bp = document.createElement('script');
        var curProtocol = window.location.protocol.split(':')[0];
        if (curProtocol === 'https') {
            bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
        } else {
            bp.src = 'http://push.zhanzhang.baidu.com/push.js';
        }
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(bp, s);

        // 360 push
        (function () {
            var httpUrl = 'http://jspassport.ssl.qhimg.com/11.0.1.js?d182b3f28525f2db83acfaaf6e696dba';
            var httpsUrl = 'https://jspassport.ssl.qhimg.com/11.0.1.js?d182b3f28525f2db83acfaaf6e696dba';
            var src = document.location.protocol == 'http:' ? httpUrl : httpsUrl;
            // document.write('<script src="' + src + '" id="sozz"><\/script>');
            var s360p = document.createElement('script');
            s360p.src = src;
            s360p.id = 'sozz';
            // var s360 = document.getElementsByTagName("script")[0];
            // s360.parentNode.insertBefore(s360p, s360);
            document.getElementsByTagName('head')[0].appendChild(s360p);
        })();
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/common/auto-sem/index.js